import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { convertFromString, convertToString, handle, toFloat, PlatformType } from "@dp/common";
import DPServices from "@dp/services";
import Base from "./Base";
import { RestaurantDetailModel } from "./models/RestaurantDetailModel";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import moment from "moment-timezone";
import { fetchDistanceFromRestuarant, fetchDistances } from "../utils/common";
import Errors, { ERROR_STRINGS } from "./Errors";
import i18next from "i18next";
var DEFAULT_LATITUDE = 28.4182867;
var DEFAULT_LONGITUDE = -81.4272471;
var Restaurant = (_dec = observable.ref, (_class = /*#__PURE__*/function (_Base) {
  _inherits(Restaurant, _Base);

  var _super = _createSuper(Restaurant);

  function Restaurant(root) {
    var _this$root, _this$root$joinWaitli;

    var _this;

    _classCallCheck(this, Restaurant);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "root", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "locationData", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restaurantSearchResults", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "detail", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "categoryIdMenuMap", {});

    _defineProperty(_assertThisInitialized(_this), "menuItemDetailMap", {});

    _defineProperty(_assertThisInitialized(_this), "restaurantIdCategoriesMap", {});

    _defineProperty(_assertThisInitialized(_this), "restaurantDetailModel", null);

    _defineProperty(_assertThisInitialized(_this), "joinWaitlistModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "loading", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_recentRestaurants", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_favoriteRestaurants", _descriptor6, _assertThisInitialized(_this));

    _this.root = root;
    _this.restaurantDetailModel = new RestaurantDetailModel();
    _this.joinWaitlistModel = (_this$root = _this.root) === null || _this$root === void 0 ? void 0 : (_this$root$joinWaitli = _this$root.joinWaitlist) === null || _this$root$joinWaitli === void 0 ? void 0 : _this$root$joinWaitli.joinWaitlistModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Restaurant, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        var _this2$root, _this2$root$user;

        return {
          data: (_this2$root = _this2.root) === null || _this2$root === void 0 ? void 0 : (_this2$root$user = _this2$root.user) === null || _this2$root$user === void 0 ? void 0 : _this2$root$user.userProfile
        };
      }, function (_ref) {
        var _this2$restaurantDeta;

        var data = _ref.data;
        (_this2$restaurantDeta = _this2.restaurantDetailModel) === null || _this2$restaurantDeta === void 0 ? void 0 : _this2$restaurantDeta.setUserProfile(data);
      });
      reaction(function () {
        var _this2$root2, _this2$root2$common;

        return {
          data: (_this2$root2 = _this2.root) === null || _this2$root2 === void 0 ? void 0 : (_this2$root2$common = _this2$root2.common) === null || _this2$root2$common === void 0 ? void 0 : _this2$root2$common.appAttributes
        };
      }, function (_ref2) {
        var _this2$restaurantDeta2;

        var data = _ref2.data;
        (_this2$restaurantDeta2 = _this2.restaurantDetailModel) === null || _this2$restaurantDeta2 === void 0 ? void 0 : _this2$restaurantDeta2.setAppAttributes(data);
      });
      reaction(function () {
        var _this2$root3, _this2$root3$user;

        return {
          data: (_this2$root3 = _this2.root) === null || _this2$root3 === void 0 ? void 0 : (_this2$root3$user = _this2$root3.user) === null || _this2$root3$user === void 0 ? void 0 : _this2$root3$user.sessionDetails
        };
      }, function (_ref3) {
        var data = _ref3.data;

        _this2.restaurantDetailModel.setSessionDetails(data);
      });
      reaction(function () {
        var _this2$root$user2;

        return {
          // TODO(Profile): Get FROM API
          data: (_this2$root$user2 = _this2.root.user) === null || _this2$root$user2 === void 0 ? void 0 : _this2$root$user2.favoriteLocations
        };
      }, function () {
        _this2.getFavLocations();
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$restaurantDetai, _this$root2, _this$root2$user, _this$restaurantDetai2, _this$root3, _this$root3$common;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_this$restaurantDetai = this.restaurantDetailModel) === null || _this$restaurantDetai === void 0 ? void 0 : _this$restaurantDetai.setUserProfile((_this$root2 = this.root) === null || _this$root2 === void 0 ? void 0 : (_this$root2$user = _this$root2.user) === null || _this$root2$user === void 0 ? void 0 : _this$root2$user.userProfile);
                (_this$restaurantDetai2 = this.restaurantDetailModel) === null || _this$restaurantDetai2 === void 0 ? void 0 : _this$restaurantDetai2.setAppAttributes((_this$root3 = this.root) === null || _this$root3 === void 0 ? void 0 : (_this$root3$common = _this$root3.common) === null || _this$root3$common === void 0 ? void 0 : _this$root3$common.appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "determineLocation",
    value: function () {
      var _determineLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var nearestLocationRestCacheData, nearestLocationRest, currentUserLocation;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.root.platformUtil.getFromLocalStorage("NEAREST_REST_INFO2");

              case 2:
                nearestLocationRestCacheData = _context4.sent;
                nearestLocationRest = convertFromString(nearestLocationRestCacheData);

                if (!(nearestLocationRest && nearestLocationRest.locationDetail)) {
                  _context4.next = 11;
                  break;
                }

                if (!nearestLocationRest.locationDetail) {
                  _context4.next = 10;
                  break;
                }

                runInAction(function () {
                  _this3.locationData = nearestLocationRest.locationData; // this.detail = nearestLocationRest.locationDetail;
                });
                return _context4.abrupt("return");

              case 10:
                runInAction(function () {
                  _this3.locationData = nearestLocationRest.locationData;
                });

              case 11:
                if (!this.locationData) {
                  currentUserLocation = this.root.user.currentUserLocation;

                  if (currentUserLocation) {
                    runInAction(function () {
                      _this3.locationData = _this3.root.user.currentUserLocation;
                    });
                  } else {
                    this.setDefaultLocationDetails();
                  }
                }

                _context4.next = 14;
                return this.setCurrentLocation();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function determineLocation() {
        return _determineLocation.apply(this, arguments);
      }

      return determineLocation;
    }()
  }, {
    key: "determineCookiedLocation",
    value: function () {
      var _determineCookiedLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(restaurantNumberFronSession, prevResturantNumberinStore) {
        var cookiedRestaurantLoaded, _restaurantDetail, _restaurantDetail2, _storedResturant, restaurantDetail;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                cookiedRestaurantLoaded = false;

                if (!restaurantNumberFronSession) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 5;
                return this.root.platformUtil.getFromSessionStorage("MY_LOCATION");

              case 5:
                _storedResturant = _context5.sent;
                restaurantDetail = _storedResturant ? JSON.parse(_storedResturant) : null;

                if (!(restaurantDetail && ((_restaurantDetail = restaurantDetail) === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantNumber) === restaurantNumberFronSession && prevResturantNumberinStore === restaurantNumberFronSession)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return", true);

              case 9:
                if (!(!restaurantDetail || ((_restaurantDetail2 = restaurantDetail) === null || _restaurantDetail2 === void 0 ? void 0 : _restaurantDetail2.restaurantNumber) !== restaurantNumberFronSession)) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 12;
                return DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumberFronSession);

              case 12:
                restaurantDetail = _context5.sent;

              case 13:
                _context5.next = 15;
                return this.root.platformUtil.saveInSessionStorage("MY_LOCATION", JSON.stringify(restaurantDetail));

              case 15:
                this.setRestaurantDetail(restaurantDetail);
                cookiedRestaurantLoaded = true;

              case 17:
                return _context5.abrupt("return", cookiedRestaurantLoaded);

              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", false);

              case 23:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 20]]);
      }));

      function determineCookiedLocation(_x, _x2) {
        return _determineCookiedLocation.apply(this, arguments);
      }

      return determineCookiedLocation;
    }()
  }, {
    key: "setRestaurantDetail",
    value: function setRestaurantDetail(restaurantDetail) {
      this.detail = restaurantDetail;
    }
  }, {
    key: "redirectToReservations",
    value: function redirectToReservations() {
      if (this.root.platformUtil.PLATFORM_TYPE !== PlatformType.APP) {
        this.root.platformUtil.goToURL("/reservations");
      }
    }
  }, {
    key: "setCurrentLocation",
    value: function () {
      var _setCurrentLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$root4,
            _this$root4$menuList,
            _this$root4$menuList$,
            _this4 = this;

        var pageSize, _yield$handle, _yield$handle2, error, response, set, nearestRest, restaurantDetail;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                pageSize = (_this$root4 = this.root) === null || _this$root4 === void 0 ? void 0 : (_this$root4$menuList = _this$root4.menuList) === null || _this$root4$menuList === void 0 ? void 0 : (_this$root4$menuList$ = _this$root4$menuList.menuListModel) === null || _this$root4$menuList$ === void 0 ? void 0 : _this$root4$menuList$.searchRestaurantsPageSize;
                _context6.next = 3;
                return handle(DPServices.Restaurant.searchRestaurants(this.locationData.coords.latitude, this.locationData.coords.longitude, pageSize));

              case 3:
                _yield$handle = _context6.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                error = _yield$handle2[0];
                response = _yield$handle2[1];

                if (error) {
                  _context6.next = 24;
                  break;
                }

                set = response;

                if (!(set.length > 0)) {
                  _context6.next = 19;
                  break;
                }

                nearestRest = set[0];
                _context6.next = 13;
                return DPServices.Restaurant.getRestaurantDetailsByNumber(nearestRest.restaurantNumber);

              case 13:
                restaurantDetail = _context6.sent;
                _context6.next = 16;
                return this.root.platformUtil.saveInLocalStorage("NEAREST_REST_INFO2", convertToString({
                  locationData: this.locationData,
                  locationDetail: restaurantDetail
                }));

              case 16:
                runInAction(function () {
                  _this4.detail = restaurantDetail;
                });
                _context6.next = 21;
                break;

              case 19:
                _context6.next = 21;
                return this.root.platformUtil.saveInLocalStorage("NEAREST_REST_INFO2", convertToString({
                  locationData: this.locationData
                }));

              case 21:
                this.mergeSearchResults(set);
                _context6.next = 27;
                break;

              case 24:
                this.setDefaultLocationDetails();
                _context6.next = 27;
                return this.setCurrentLocation();

              case 27:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setCurrentLocation() {
        return _setCurrentLocation.apply(this, arguments);
      }

      return setCurrentLocation;
    }()
  }, {
    key: "mergeSearchResults",
    value: function mergeSearchResults(result) {
      var currentResultSet = this._restaurantSearchResults;

      if ((currentResultSet === null || currentResultSet === void 0 ? void 0 : currentResultSet.length) > 0) {
        if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
          var _this$_restaurantSear;

          var existingSet = currentResultSet;
          var newSet = result;
          var nonExistantSet = [];
          newSet.forEach(function (newRest) {
            var found = false;

            var _iterator = _createForOfIteratorHelper(existingSet),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var currentItem = _step.value;
                var existingRest = currentItem;

                if (existingRest.restaurantNumber === newRest.restaurantNumber) {
                  // Existing Entry
                  found = true;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (!found) {
              nonExistantSet.push(newRest);
            }
          });

          (_this$_restaurantSear = this._restaurantSearchResults).push.apply(_this$_restaurantSear, nonExistantSet);
        }
      } else {
        this._restaurantSearchResults = result;
      }
    }
  }, {
    key: "setDefaultLocationDetails",
    value: function setDefaultLocationDetails() {
      this.locationData = {
        coords: {
          latitude: DEFAULT_LATITUDE,
          longitude: DEFAULT_LONGITUDE,
          altitude: 0,
          accuracy: null,
          altitudeAccuracy: null,
          heading: null,
          speed: null
        },
        timestamp: moment().toDate().getTime()
      };
    } // TODO(RD): verify this method

  }, {
    key: "getRestaurantPhoneNumberByType",
    value: function getRestaurantPhoneNumberByType(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.type === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "getRestaurantCurrentWeekClosedStatus",
    value: function getRestaurantCurrentWeekClosedStatus(closedDays, timezone) {
      var restaurantClosedStatusArr = [];

      if (timezone) {
        for (var i = 0; i < 7; i++) {
          var _this$restaurantDetai3;

          restaurantClosedStatusArr.push((_this$restaurantDetai3 = this.restaurantDetailModel) === null || _this$restaurantDetai3 === void 0 ? void 0 : _this$restaurantDetai3.isRestaurantClosed(timezone, closedDays, i));
        }
      }

      return restaurantClosedStatusArr;
    }
  }, {
    key: "handleFetchRestaurantError",
    value: function handleFetchRestaurantError(err) {
      var _this$root5, _this$root5$platformU;

      if (((_this$root5 = this.root) === null || _this$root5 === void 0 ? void 0 : (_this$root5$platformU = _this$root5.platformUtil) === null || _this$root5$platformU === void 0 ? void 0 : _this$root5$platformU.PLATFORM_TYPE) === "APP") {
        var _DPServices$Cart$pars;

        var errObj = err;
        var faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;
        var haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

        if (haveErrorDescription) {
          throw new Error(haveErrorDescription);
        } else {
          throw Errors.FETCH_LOCATION_RESTAURANT_FAILED;
        }
      } else {
        return this.root.platformUtil.redirectToURL("/locations/location-search?invalidRest=true");
      }
    }
  }, {
    key: "getBaseDomainURL",
    value: function getBaseDomainURL() {
      var _this$root6, _this$root6$platformU;

      return (_this$root6 = this.root) === null || _this$root6 === void 0 ? void 0 : (_this$root6$platformU = _this$root6.platformUtil) === null || _this$root6$platformU === void 0 ? void 0 : _this$root6$platformU.getBaseDomainURL();
    }
  }, {
    key: "fetchLocationRestaurant",
    value: function () {
      var _fetchLocationRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(currentLocation, restaurantNumber, source, hideLoader) {
        var _this5 = this;

        var _err, restaurantDetails, _this$root7, _this$root7$common, _this$root7$common$ap, _this$root7$common$ap2, _restaurantDetails, _restaurantDetails$fe, _yield$handle3, _yield$handle4, _this$root8, _this$root8$common, _this$root8$common$ap, _this$root8$common$ap2, _this$root9, _this$root9$common, _this$root9$common$ap, _this$root9$common$ap2, _this$root10, _this$root10$platform, _currentLocation$coor, _currentLocation$coor2, _restaurantDetails2, coordsObj, resultObj;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _err = null;
                restaurantDetails = null;

                if (!hideLoader) {
                  runInAction(function () {
                    _this5.loading = true;
                  });
                }

                if (!(typeof restaurantNumber === "undefined" || restaurantNumber.length <= 0 || Number.isNaN(Number(restaurantNumber)))) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return", null);

              case 6:
                if (!restaurantNumber) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 9;
                return handle(DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumber));

              case 9:
                _yield$handle3 = _context7.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                _err = _yield$handle4[0];
                restaurantDetails = _yield$handle4[1]; // the targeter call for web happens from next/src/pages/locations/index

                if (this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP && ((_this$root7 = this.root) === null || _this$root7 === void 0 ? void 0 : (_this$root7$common = _this$root7.common) === null || _this$root7$common === void 0 ? void 0 : (_this$root7$common$ap = _this$root7$common.appAttributes) === null || _this$root7$common$ap === void 0 ? void 0 : (_this$root7$common$ap2 = _this$root7$common$ap.configs) === null || _this$root7$common$ap2 === void 0 ? void 0 : _this$root7$common$ap2.enableTargeter) === "true") {
                  this.getTargetersForCurrentRestaurant((_this$root8 = this.root) === null || _this$root8 === void 0 ? void 0 : (_this$root8$common = _this$root8.common) === null || _this$root8$common === void 0 ? void 0 : (_this$root8$common$ap = _this$root8$common.appAttributes) === null || _this$root8$common$ap === void 0 ? void 0 : (_this$root8$common$ap2 = _this$root8$common$ap.configs) === null || _this$root8$common$ap2 === void 0 ? void 0 : _this$root8$common$ap2.targeterPath, restaurantNumber, (_this$root9 = this.root) === null || _this$root9 === void 0 ? void 0 : (_this$root9$common = _this$root9.common) === null || _this$root9$common === void 0 ? void 0 : (_this$root9$common$ap = _this$root9$common.appAttributes) === null || _this$root9$common$ap === void 0 ? void 0 : (_this$root9$common$ap2 = _this$root9$common$ap.concept) === null || _this$root9$common$ap2 === void 0 ? void 0 : _this$root9$common$ap2.conceptCode);
                }

                if (!(this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP && !((_restaurantDetails = restaurantDetails) !== null && _restaurantDetails !== void 0 && (_restaurantDetails$fe = _restaurantDetails.features) !== null && _restaurantDetails$fe !== void 0 && _restaurantDetails$fe.locationDetailEnabled))) {
                  _context7.next = 17;
                  break;
                }

                (_this$root10 = this.root) === null || _this$root10 === void 0 ? void 0 : (_this$root10$platform = _this$root10.platformUtil) === null || _this$root10$platform === void 0 ? void 0 : _this$root10$platform.goBack();
                return _context7.abrupt("return", null);

              case 17:
                if (_err) {
                  this.handleFetchRestaurantError(_err);
                }

                if (!(source !== "CREATE_ACCOUNT" && source !== "RESERVATION")) {
                  _context7.next = 26;
                  break;
                }

                if (!restaurantDetails) {
                  _context7.next = 26;
                  break;
                }

                coordsObj = {
                  latitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor = currentLocation.coords) === null || _currentLocation$coor === void 0 ? void 0 : _currentLocation$coor.latitude,
                  longitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor2 = currentLocation.coords) === null || _currentLocation$coor2 === void 0 ? void 0 : _currentLocation$coor2.longitude,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context7.next = 23;
                return fetchDistanceFromRestuarant(coordsObj, restaurantDetails);

              case 23:
                resultObj = _context7.sent;
                restaurantDetails.mapBoxDistance = resultObj[(_restaurantDetails2 = restaurantDetails) === null || _restaurantDetails2 === void 0 ? void 0 : _restaurantDetails2.atgRestaurantId];
                this.restaurantDetailModel.selectedRestaurantInLocation = restaurantDetails;

              case 26:
                runInAction(function () {
                  _this5.loading = false;
                });
                return _context7.abrupt("return", restaurantDetails);

              case 30:
                _context7.prev = 30;
                _context7.t0 = _context7["catch"](0);
                runInAction(function () {
                  _this5.loading = false;
                });
                this.root.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context7.t0.message);
                throw _context7.t0;

              case 35:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 30]]);
      }));

      function fetchLocationRestaurant(_x3, _x4, _x5, _x6) {
        return _fetchLocationRestaurant.apply(this, arguments);
      }

      return fetchLocationRestaurant;
    }()
  }, {
    key: "fetchTargetter",
    value: function () {
      var _fetchTargetter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(restaurantNumber, isMobile) {
        var _this$root11, _this$root11$common, _this$root11$common$a, _this$root11$common$a2;

        var _this$root12, _this$root12$common, _this$root12$common$a, _this$root12$common$a2, _this$root13, _this$root13$common, _this$root13$common$a, _this$root13$common$a2;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (((_this$root11 = this.root) === null || _this$root11 === void 0 ? void 0 : (_this$root11$common = _this$root11.common) === null || _this$root11$common === void 0 ? void 0 : (_this$root11$common$a = _this$root11$common.appAttributes) === null || _this$root11$common$a === void 0 ? void 0 : (_this$root11$common$a2 = _this$root11$common$a.configs) === null || _this$root11$common$a2 === void 0 ? void 0 : _this$root11$common$a2.enableTargeter) === "true") {
                  this.getTargetersForCurrentRestaurant((_this$root12 = this.root) === null || _this$root12 === void 0 ? void 0 : (_this$root12$common = _this$root12.common) === null || _this$root12$common === void 0 ? void 0 : (_this$root12$common$a = _this$root12$common.appAttributes) === null || _this$root12$common$a === void 0 ? void 0 : (_this$root12$common$a2 = _this$root12$common$a.configs) === null || _this$root12$common$a2 === void 0 ? void 0 : _this$root12$common$a2.targeterPath, restaurantNumber, (_this$root13 = this.root) === null || _this$root13 === void 0 ? void 0 : (_this$root13$common = _this$root13.common) === null || _this$root13$common === void 0 ? void 0 : (_this$root13$common$a = _this$root13$common.appAttributes) === null || _this$root13$common$a === void 0 ? void 0 : (_this$root13$common$a2 = _this$root13$common$a.concept) === null || _this$root13$common$a2 === void 0 ? void 0 : _this$root13$common$a2.conceptCode, !isMobile && "WEB");
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function fetchTargetter(_x7, _x8) {
        return _fetchTargetter.apply(this, arguments);
      }

      return fetchTargetter;
    }()
  }, {
    key: "getRecentLocations",
    value: function () {
      var _getRecentLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this$root14, _this$root14$user, _this$root14$user$fav;

        var favouriteLocationsIdSet, recentLocationNumbers, _currentLocation$coor3, _currentLocation$coor4, _currentLocation$coor5, _currentLocation$coor6, _yield$handle5, _yield$handle6, _err2, recentLocations, currentLocation, coordsObj, resultObj;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                favouriteLocationsIdSet = new Set();
                (_this$root14 = this.root) === null || _this$root14 === void 0 ? void 0 : (_this$root14$user = _this$root14.user) === null || _this$root14$user === void 0 ? void 0 : (_this$root14$user$fav = _this$root14$user.favoriteLocations) === null || _this$root14$user$fav === void 0 ? void 0 : _this$root14$user$fav.forEach(function (favouriteLocation) {
                  favouriteLocationsIdSet.add(favouriteLocation.atgRestaurantId);
                });
                _context9.next = 4;
                return this.root.platformUtil.getFromLocalStorage("MY_LOCATIONS").then(JSON.parse);

              case 4:
                recentLocationNumbers = _context9.sent;

                if (!(recentLocationNumbers && Array.isArray(recentLocationNumbers))) {
                  _context9.next = 26;
                  break;
                }

                _context9.next = 8;
                return handle(DPServices.Restaurant.getRestaurantByNumbers(recentLocationNumbers.toString()));

              case 8:
                _yield$handle5 = _context9.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                _err2 = _yield$handle6[0];
                recentLocations = _yield$handle6[1];

                if (!_err2) {
                  _context9.next = 14;
                  break;
                }

                throw DPServices.Common.checkAndGetErrorDescription(_err2) || Errors.GET_RECENT_LOCATION;

              case 14:
                recentLocations === null || recentLocations === void 0 ? void 0 : recentLocations.forEach(function (recentLocation) {
                  if (favouriteLocationsIdSet !== null && favouriteLocationsIdSet !== void 0 && favouriteLocationsIdSet.has(recentLocation.atgRestaurantId)) {
                    recentLocation.isFavourite = true;
                  }
                });
                _context9.next = 17;
                return this.root.user.obtainUserGeoCoordinates();

              case 17:
                _context9.next = 19;
                return this.root.user.currentUserLocation;

              case 19:
                currentLocation = _context9.sent;
                coordsObj = {
                  latitude: (_currentLocation$coor3 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor4 = currentLocation.coords) === null || _currentLocation$coor4 === void 0 ? void 0 : _currentLocation$coor4.latitude) !== null && _currentLocation$coor3 !== void 0 ? _currentLocation$coor3 : DEFAULT_LATITUDE,
                  longitude: (_currentLocation$coor5 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor6 = currentLocation.coords) === null || _currentLocation$coor6 === void 0 ? void 0 : _currentLocation$coor6.longitude) !== null && _currentLocation$coor5 !== void 0 ? _currentLocation$coor5 : DEFAULT_LONGITUDE,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context9.next = 23;
                return fetchDistances(coordsObj, recentLocations);

              case 23:
                resultObj = _context9.sent;
                recentLocations.forEach(function (location) {
                  // TODO(LS): change to atgrestid if doesn't work
                  var calculateddistance = resultObj[location === null || location === void 0 ? void 0 : location.restaurantNumber];
                  location.mapBoxDistance = calculateddistance;
                  return location;
                });
                this.recentRestaurants = recentLocations;

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRecentLocations() {
        return _getRecentLocations.apply(this, arguments);
      }

      return getRecentLocations;
    }()
  }, {
    key: "getFavLocations",
    value: function () {
      var _getFavLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this$root$user;

        var userFavoriteLocations, favoriteLocationNumbers, _favoriteLocationNumb, _currentLocation$coor7, _currentLocation$coor8, _currentLocation$coor9, _currentLocation$coor10, _yield$handle7, _yield$handle8, _err3, favoriteLocations, currentLocation, coordsObj, resultObj;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                userFavoriteLocations = (_this$root$user = this.root.user) === null || _this$root$user === void 0 ? void 0 : _this$root$user.favoriteLocations;
                favoriteLocationNumbers = userFavoriteLocations === null || userFavoriteLocations === void 0 ? void 0 : userFavoriteLocations.map(function (item) {
                  return item.restaurantNumber;
                });

                if (!(favoriteLocationNumbers && Array.isArray(favoriteLocationNumbers))) {
                  _context10.next = 24;
                  break;
                }

                _context10.next = 5;
                return handle(DPServices.Restaurant.getRestaurantByNumbers(favoriteLocationNumbers === null || favoriteLocationNumbers === void 0 ? void 0 : (_favoriteLocationNumb = favoriteLocationNumbers.join(",")) === null || _favoriteLocationNumb === void 0 ? void 0 : _favoriteLocationNumb.toString()));

              case 5:
                _yield$handle7 = _context10.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                _err3 = _yield$handle8[0];
                favoriteLocations = _yield$handle8[1];

                if (!_err3) {
                  _context10.next = 11;
                  break;
                }

                throw DPServices.Common.checkAndGetErrorDescription(_err3) || Errors.GET_FAVORITED_LOCATION;

              case 11:
                favoriteLocations.forEach(function (favouriteLocation) {
                  favouriteLocation.isFavourite = true;
                });
                _context10.next = 14;
                return this.root.user.obtainUserGeoCoordinates();

              case 14:
                _context10.next = 16;
                return this.root.user.currentUserLocation;

              case 16:
                currentLocation = _context10.sent;
                coordsObj = {
                  latitude: (_currentLocation$coor7 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor8 = currentLocation.coords) === null || _currentLocation$coor8 === void 0 ? void 0 : _currentLocation$coor8.latitude) !== null && _currentLocation$coor7 !== void 0 ? _currentLocation$coor7 : DEFAULT_LATITUDE,
                  longitude: (_currentLocation$coor9 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor10 = currentLocation.coords) === null || _currentLocation$coor10 === void 0 ? void 0 : _currentLocation$coor10.longitude) !== null && _currentLocation$coor9 !== void 0 ? _currentLocation$coor9 : DEFAULT_LONGITUDE,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context10.next = 20;
                return fetchDistances(coordsObj, favoriteLocations);

              case 20:
                resultObj = _context10.sent;
                favoriteLocations.forEach(function (location) {
                  var calculateddistance = resultObj[location === null || location === void 0 ? void 0 : location.restaurantNumber];
                  location.mapBoxDistance = calculateddistance;
                  return location;
                });
                favoriteLocations.sort(function (a, b) {
                  return a.restaurantName > b.restaurantName ? 1 : -1;
                });
                this.favoriteRestaurants = favoriteLocations;

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getFavLocations() {
        return _getFavLocations.apply(this, arguments);
      }

      return getFavLocations;
    }()
  }, {
    key: "getUserLocations",
    value: function () {
      var _getUserLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _yield$handle9, _yield$handle10, err;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return handle(Promise.all([this.getRecentLocations(), this.getFavLocations()]));

              case 2:
                _yield$handle9 = _context11.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 1);
                err = _yield$handle10[0];

                if (err && this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.root.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, err.message);
                }

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getUserLocations() {
        return _getUserLocations.apply(this, arguments);
      }

      return getUserLocations;
    }()
  }, {
    key: "getTargetersForCurrentRestaurant",
    value: function () {
      var _getTargetersForCurrentRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(targeterPath, restNumber, conceptCode, channel) {
        var _DPServices$Restauran, data;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return (_DPServices$Restauran = DPServices.Restaurant) === null || _DPServices$Restauran === void 0 ? void 0 : _DPServices$Restauran.getTargetersForCurrentRestaurant(targeterPath, restNumber, conceptCode, channel);

              case 3:
                data = _context12.sent;
                this.restaurantDetailModel.setTargeters(data);
                _context12.next = 10;
                break;

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);
                this.restaurantDetailModel.setTargeters({});

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 7]]);
      }));

      function getTargetersForCurrentRestaurant(_x9, _x10, _x11, _x12) {
        return _getTargetersForCurrentRestaurant.apply(this, arguments);
      }

      return getTargetersForCurrentRestaurant;
    }()
  }, {
    key: "setWaitlistRestaurantDetails",
    value: function () {
      var _setWaitlistRestaurantDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(restNum) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function setWaitlistRestaurantDetails(_x13) {
        return _setWaitlistRestaurantDetails.apply(this, arguments);
      }

      return setWaitlistRestaurantDetails;
    }()
  }, {
    key: "showCancelWaitlistSuccessMessage",
    value: function showCancelWaitlistSuccessMessage() {
      var _this$root15, _this$root15$appMessa;

      (_this$root15 = this.root) === null || _this$root15 === void 0 ? void 0 : (_this$root15$appMessa = _this$root15.appMessages) === null || _this$root15$appMessa === void 0 ? void 0 : _this$root15$appMessa.showError(i18next.t("text.rd.from_leave_waitlist_flow_header", {
        defaultValue: "Waitlist cancellation"
      }), i18next.t("text.rd.from_leave_waitlist_flow_body", {
        defaultValue: "You have been successfully removed from the waitlist."
      }), null);
    }
  }, {
    key: "favoriteRestaurants",
    get: function get() {
      return this._favoriteRestaurants;
    },
    set: function set(data) {
      var _this6 = this;

      runInAction(function () {
        _this6._favoriteRestaurants = data;
      });
    }
  }, {
    key: "recentRestaurants",
    get: function get() {
      return this._recentRestaurants;
    },
    set: function set(data) {
      var _this7 = this;

      runInAction(function () {
        _this7._recentRestaurants = data;
      });
    }
  }, {
    key: "restaurantSearchResults",
    get: function get() {
      var results = this._restaurantSearchResults && this._restaurantSearchResults.length > 0 ? this._restaurantSearchResults : [];
      return results.slice().sort(function (restA, restB) {
        //@ts-ignore TODO(DL) - Look into miles parameter
        var milesA = toFloat(restA.miles, 0); //@ts-ignore TODO(DL) - Look into miles parameter

        var milesB = toFloat(restB.miles, 0);
        return milesA - milesB;
      });
    }
  }, {
    key: "isLocationWaitListEnabledForMenuHeader",
    get: function get() {
      var _this$currentRestaura, _this$currentRestaura2;

      return (_this$currentRestaura = this.currentRestaurant) === null || _this$currentRestaura === void 0 ? void 0 : (_this$currentRestaura2 = _this$currentRestaura.features) === null || _this$currentRestaura2 === void 0 ? void 0 : _this$currentRestaura2.waitListEnabled;
    }
  }, {
    key: "restaurantId",
    get: function get() {
      if (this.detail) {
        return this.detail.atgRestaurantId;
      } else {
        return null;
      }
    }
  }, {
    key: "currentRestaurant",
    get: function get() {
      return this.detail;
    }
  }, {
    key: "isRestaurantFavorite",
    get: function get() {
      var _this$root$user2,
          _this$root$user3,
          _this8 = this;

      var userLoggedIn = (_this$root$user2 = this.root.user) === null || _this$root$user2 === void 0 ? void 0 : _this$root$user2.isLoggedIn;
      var favoriteLocations = (_this$root$user3 = this.root.user) === null || _this$root$user3 === void 0 ? void 0 : _this$root$user3.favoriteLocations;
      if (!userLoggedIn) return false;
      return favoriteLocations === null || favoriteLocations === void 0 ? void 0 : favoriteLocations.some(function (location) {
        var _this8$restaurantDeta;

        if (location.restaurantNumber === ((_this8$restaurantDeta = _this8.restaurantDetailModel.selectedRestaurantInLocation) === null || _this8$restaurantDeta === void 0 ? void 0 : _this8$restaurantDeta.restaurantNumber)) {
          return location === null || location === void 0 ? void 0 : location.isFavorite;
        }

        return false;
      });
    }
  }]);

  return Restaurant;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locationData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restaurantSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "detail", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_recentRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_favoriteRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "favoriteRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favoriteRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantSearchResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationWaitListEnabledForMenuHeader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationWaitListEnabledForMenuHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRestaurantDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRestaurantDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentRestaurant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentRestaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mergeSearchResults", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mergeSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDefaultLocationDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDefaultLocationDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRestaurantFavorite", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRestaurantFavorite"), _class.prototype)), _class));
export { Restaurant as default };